import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { BaseViewerComponent } from '../base-viewer/base-viewer.component';

@Component({
    selector: 'sh-warc-viewer',
    templateUrl: './warc-viewer.component.html',
    styleUrls: ['./warc-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,

    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    standalone: true
})
export class WarcViewerComponent extends BaseViewerComponent {}
